import Controller from 'controllers/controller';
import Bus from 'tools/bus';
import createHistory from "history/createBrowserHistory";

class HistoryController extends Controller {
    constructor(app) {
        super(app);
        
        this.history = createHistory();
        this.bus = new Bus(this);
        
        this.ignoreNextPageChange = false;
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.history.listen(this.onHistoryChange);
    }
    
    onHistoryChange(location, action) {
        // Ignore pushed states
        if (action === 'PUSH') {
            return;
        }

        this.bus.emit('change', { location, action });
    }
    
    push(url) {
        this.history.push(url);
    }
}

export default HistoryController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/history.js